import { createReducer, on } from '@ngrx/store';
import { produce } from 'immer';
import { effectsActions, panelActions } from './store.actions';
import { PresenceState, initialPresenceState } from './store.models';

export const PresenceKey = 'DashboardFeaturePresence';

export const presenceReducer = createReducer(
  initialPresenceState,
  on(
    panelActions.init,
    (state, { key }): PresenceState =>
      produce(state, (draft) => {
        draft.watchedKeys = [...(draft.watchedKeys || []), key];
      })
  ),
  on(
    panelActions.destroy,
    (state, { key }): PresenceState =>
      produce(state, (draft) => {
        draft.watchedKeys = draft.watchedKeys?.filter((k) => k !== key);
      })
  ),
  on(
    effectsActions.watchSuccess,
    (state, { presentUsers }): PresenceState =>
      produce(state, (draft) => {
        draft.presentUsers = presentUsers;
      })
  ),
  on(
    effectsActions.watchFailure,
    effectsActions.heartbeatFailure,
    (state, { error }): PresenceState =>
      produce(state, (draft) => {
        draft.error = error;
      })
  )
);
